import { SidebarSubitemType } from "@/components/layout/business/Sidebar.vue";
import router from "@/router";
import type { RouteRecordRaw } from "vue-router";
import { ScopeType } from "@/types/scopes";

export function useDynamicOpportunityRoutes() {
  function addDynamicOpportunityRoutes(scopeList: ScopeType[]) {
    // Aggiungi la rotta di default per le opportunità.
    // Il privilege del padre va ridichiarato: useMenuPermissions valuta le voci
    // di menu via router.getRoutes(), che restituisce il meta del singolo record
    // senza il merge coi padri. Senza questa riga la voce "Pipeline" resterebbe
    // visibile in sidebar anche dove opportunities_page è Hidden.
    // const defaultRoute = {
    //   path: "default",
    //   name: "manageOpportunity-default",
    //   component: () => import("@/pages/Opportunities/OpportunitiesIndex.vue"),
    //   meta: {
    //     privilege: {
    //       resource: "opportunities_page",
    //       attribute: "view",
    //     },
    //   },
    // };
    // router.addRoute("manageOpportunity-root", defaultRoute);
    // Aggiungi rotte dinamiche per ogni scope
    (scopeList || []).forEach((scope: ScopeType) => {
      // assicurati che il name sia unico
      const routeName = `manageOpportunity-${scope.code}`;
      // evita duplicati
      if (router.hasRoute(routeName)) return;

      const childRoute: RouteRecordRaw = {
        path: scope.code,
        name: routeName,
        meta: {
          scopeName: scope.name,
          scopeId: scope.id,
        },
        component: () => import("@/pages/Opportunities/OpportunitiesIndex.vue"), // lazy-load
      };
      router.addRoute("manageOpportunity-root", childRoute);
    });
  }

  function buildOpportunitySidebarSubitems(scopeList: ScopeType[]) {
    const opportunityRouteSubitems: SidebarSubitemType[] = [];
    opportunityRouteSubitems.push({
      text: "Default",
      to: { name: "manageOpportunity-default-path" },
      id: null
    });
    scopeList.forEach((scope) => {
      opportunityRouteSubitems.push({
        text: scope.name,
        to: { name: `manageOpportunity-${scope.code}` },
        id: scope.id
      });
    });
    return opportunityRouteSubitems;
  }

  return { addDynamicOpportunityRoutes, buildOpportunitySidebarSubitems };
}
